import script from "./VoteSet.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoteSet.vue?vue&type=script&setup=true&lang=ts"

import "./VoteSet.vue?vue&type=style&index=0&id=25d1f0e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d1f0e6"]])

export default __exports__